import type { ComponentType } from 'react';
import { createContext } from 'react';

import type { UBFFGateway } from '@shared/types/frontend/ubff-gateway';

import displayName from '@shared/utils-frontend/display-name';

type ContextProps = {
  uBFFGateway: UBFFGateway;
};

// @ts-expect-error missing properties
const UBFFContext = createContext<UBFFGateway>({});

export const withUBFFContext = <P extends ContextProps>(
  Component: ComponentType<P>,
) => {
  const component = (props: Omit<P, 'uBFFGateway'>) => (
    <UBFFContext.Consumer>
      {(uBFFGateway: UBFFGateway) => (
        // @ts-expect-error we expect that backendGateway can be overwritten in the unit tests
        <Component uBFFGateway={uBFFGateway} {...(props as P)} />
      )}
    </UBFFContext.Consumer>
  );

  component.displayName = displayName(Component);

  return component;
};

export default UBFFContext;
